import { CompanyModel } from 'api/model';
import useCompanies from 'contexts/basicData/useCompanies';
import { useMemo, useState } from 'react';
import { HubFilterValue } from './utils';

const useToFromAddressAssignmentFilter = () => {
  const { companies } = useCompanies();
  const [selectedFromCompany, setSelectedFromCompany] =
    useState<CompanyModel | null>(null);
  const [selectedToCompany, setSelectedToCompany] =
    useState<CompanyModel | null>(null);
  // Hubbfiltret på frånadressen: valda hubbars companyID och/eller "Övriga". Tom = alla.
  const [selectedHubs, setSelectedHubs] = useState<Set<HubFilterValue>>(
    () => new Set()
  );

  // Aktiva företag flaggade som Zäkra-hub, i namnordning. Samma lista är både dropdownens
  // alternativ och facit för vad som räknas som hubb i filtreringen, så inget ben kan hamna
  // utanför både hubbarna och "Övriga".
  const hubs = useMemo(
    () =>
      companies
        .filter((company) => company.isZakraHub === true)
        .sort((a, b) => a.name.localeCompare(b.name, 'sv')),
    [companies]
  );

  return useMemo(() => {
    return {
      selectedFromCompany,
      setSelectedFromCompany,
      selectedToCompany,
      setSelectedToCompany,
      hubs,
      selectedHubs,
      setSelectedHubs,
    };
  }, [hubs, selectedFromCompany, selectedHubs, selectedToCompany]);
};

export default useToFromAddressAssignmentFilter;
